import Api from "../baseApi";

const state = {
  all: [],
  detail: {},
  ids: []

};
const getters = {
  setting: (state) => {
    return state.setting;
  },
};
const actions = {
  getAll: async (context, param) => {
    let url = `/management/products?search=${param.search}`;
    if (param.type > -1)
      url += "&type=" + param.type;
    let d = (await Api.get(url)).data;
    context.commit("getAll", d);
  },
  getIds: async (context) => {
    let url = `/management/products/ids`;
    let d = (await Api.get(url)).data;
    context.commit("getIds", d);
  },
  createOrUpdate: async (context, data) => {
    let url = `/management/products`;
    (await Api.post(url, data)).data;
  },
  delete: async (context, id) => {
    Api.delete(`/management/products/${id}`);
  },
  get: async (context, id) => {
    let url = `/management/products/${id}`;
    let data = (await Api.get(url)).data;
    context.commit("get", data);
  },
};
const mutations = {
  getAll(state, settings) {
    state.all = settings;
  },
  get(state, data) {

    state.detail = data;
  },
  getIds(state, data) {
    state.ids = data;
  },

};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
